var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverBoomReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    zoomAndPan: "magnify",
    viewBox: "0 0 1440 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c4506bc468"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 529.507812 47 L 942.007812 47 L 942.007812 728.644531 L 529.507812 728.644531 Z M 529.507812 47 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c4506bc468)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b75a20",
    d: "M 584.058594 47.109375 L 529.511719 47.109375 L 887.621094 387.945312 L 529.507812 728.78125 L 584.058594 728.78125 L 942.167969 387.945312 Z M 584.058594 47.109375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverBoomReport);
export default __webpack_public_path__ + "static/media/SilverBoom Report.c6384a7c336a121a4fae334d4df86d12.svg";
export { ForwardRef as ReactComponent };